import { useState, useRef } from "react";
import MainNavigation from "../components/MainNavigation";
import { motion } from 'framer-motion';
import "./Vaceai.css";

import Button from "../shared/components/FormElements/Button/Button";

const Vaceai = () => {
  const scrollRef = useRef(null);
  const [isScreenHovered, setIsScreenHovered] = useState(false);

  const handleHoverStart = () => {
    setIsScreenHovered(true);
  };

  const handleHoverEnd = () => {
    setIsScreenHovered(false);
  };

  return (
    <div className="vaceai">
      <MainNavigation />
      <div className="top">
        <div className="topelements">
          <div className="titles">
            <motion.div
                className="ace-your-interview"
                initial={{ opacity: 0, scale: 1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.5, duration: 1 }}
            >
              <div>Ace Your Interview</div>
            </motion.div>
            <motion.div
                className="we-help-you-container"
                initial={{ opacity: 0, scale: 1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.5, duration: 1 }}
            >
            <div>
              <p className="we-help-you">{`We help you prepare for your interview based on your skill set, background, and resume `}</p>
              <p className="we-help-you">
                to uniquely tailor you preparation and track progress over time.
              </p>
            </div>
            </motion.div>
            <motion.div
                className="buttons"
                initial={{ opacity: 0, scale: 1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.5, duration: 1 }}
            >
            <div className="buttons">
              <motion.div 
                className="signup"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <div className="sign-up"><Button to={'/auth'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0 }}>SIGN UP</p></Button></div>
              </motion.div>
              <div className="waitlist">
                <div className="sign-up"><Button to={'mailto:propagate.jpn@gmail.com'} transparent>CONTACT US</Button></div>
              </div>
            </div>
            </motion.div>
          </div>
          <motion.div
            className="screen"
            whileHover={{ scale: 1.1, y: 10 }}
            onHoverStart={handleHoverStart}
            onHoverEnd={handleHoverEnd}
          >
          
            <div className="graybar">
              <div className="threedots">
                <div className="reddot" />
                <div className="yellowdot" />
                <div className="greendot" />
              </div>
            </div>
            {!isScreenHovered && 
            <div className="mainscreen">
              <div className="evaluation">
                <motion.div
                  className="clarity"
                  initial={{ opacity: 1, x: -1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 1, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                >
                <div>
                  <div className="jobfit">Clarity</div>
                </div>
                </motion.div>
                <motion.div
                  className="clarity"
                  initial={{ opacity: 1, x: -1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 1.25, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                >
                <div>
                  <div className="jobfit">Confidence</div>
                </div>
                </motion.div>
                <motion.div
                  className="clarity"
                  initial={{ opacity: 1, x: -1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 1.5, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                >
                <div>
                  <div className="jobfit">Relevance</div>
                </div>
                </motion.div>
                <motion.div
                  className="clarity"
                  initial={{ opacity: 1, x: -1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 1.75, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                >
                <div>
                  <div className="jobfit">Job Fit</div>
                </div>
                </motion.div>
                <motion.div
                  className="clarity"
                  initial={{ opacity: 1, x: -1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 2, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                >
                <div>
                  <div className="jobfit">Emotion</div>
                </div>
                </motion.div>
                <motion.div
                  className="clarity"
                  initial={{ opacity: 1, x: -1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 2.25, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                >
                <div>
                  <div className="jobfit">Filler Words</div>
                </div>
                </motion.div>
              </div>
              <div className="interview">
                <motion.div
                  className="question"
                  initial={{ opacity: 1, x: 1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 1, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                >
                <div>
                  Q. Have you gone through our website? What can be improved?
                </div>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, x: 1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 1.625, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                  whileHover={{ scale: 1 }}
                >
                <img className="video-icon" alt="" src="/video@2x.png" />
                </motion.div>
                <motion.div
                  className="transcript"
                  initial={{ opacity: 1, x: 1000 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 2.25, duration: 0.75, repeat: Infinity, repeatType: "reverse", repeatDelay: 4 }}
                >
                  <div className="brainstorm-tailored-questions">
                    Transcript:
                  </div>
                  <div className="firstline">
                    <div className="yes-i-investigated">{`Yes, I investigated your website. In general, I had a great time going through your website. `}</div>
                  </div>
                  <div className="firstline1">
                    <div className="umm-i-think">
                      Umm, I think the design can be slightly improved by having
                      less text and more visual elements umm like images and
                      videos.
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
            }
            {isScreenHovered &&
              <div className="mainscreen">
              <div className="evaluation">
                <div className="clarity">
                  <div className="jobfit">Clarity</div>
                </div>               
                <div className="clarity">
                  <div className="jobfit">Confidence</div>
                </div>
                <div className="clarity">
                  <div className="jobfit">Relevance</div>
                </div>
                <div className="clarity">
                  <div className="jobfit">Job Fit</div>
                </div>
                <div className="clarity">
                  <div className="jobfit">Emotion</div>
                </div>
                <div className="clarity">
                  <div className="jobfit">Filler Words</div>
                </div>
              </div>
              <div className="interview">
                <div className="question">
                  Q. Have you gone through our website? What can be improved?
                </div>
                <img className="video-icon" alt="" src="/video@2x.png" />
                <div className="transcript">
                  <div className="brainstorm-tailored-questions">
                    Transcript:
                  </div>
                  <div className="firstline">
                    <div className="yes-i-investigated">{`Yes, I investigated your website. In general, I had a great time going through your website. `}</div>
                  </div>
                  <div className="firstline1">
                    <div className="umm-i-think">
                      Umm, I think the design can be slightly improved by having
                      less text and more visual elements umm like images and
                      videos.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
          </motion.div>
        </div>
      </div>
      <div className="services" id='services'>
        <div className="serviceinner">
          <div className="servicetitle">
            <div className="you-and-vaceai-container">
              <span className="you-and">
                <b>You and</b>
                <span className="span">{` `}</span>
              </span>
              <span>
                <span className="vaceai1">VACE.AI</span>
              </span>
              <span>
                <span>{` `}</span>
                <b className="you-and">together</b>
              </span>
            </div>
          </div>
          <div className="brainstorming">
            <div className="brainstormingtext">
              <div className="brainstorm-tailored-questions">
                Brainstorm Tailored Questions
              </div>
              <div className="brainstorming-questions-can">
                Brainstorming questions can be hard sometimes. If you struggle
                with it, vace.ai can help you brainstorm questions together for
                smooth and effective interview practice based on the job
                description.
              </div>
            </div>
            <div className="brainstormingviz">
              <motion.div
                  className="inputs"
                  initial={{ opacity: 0, scale: 0.5 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0, duration: 0.25 }}
                  viewport={{ root: scrollRef }}
              >
                <b className="you-and-vaceai-container">Job Description</b>
                <img className="document-icon" alt="" src="/document@2x.png" />
                <b className="your-questions">Your Questions</b>
                <img className="document-icon1" alt="" src="/document@2x.png" />
              </motion.div>
              <motion.div
                  className="arrowframe"
                  initial={{ opacity: 0, scale: 0.5 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.25, duration: 0.25 }}
                  viewport={{ root: scrollRef }}
              >
                <img className="arrow-icon" alt="" src="/arrow.svg" />
              </motion.div>
              <motion.div
                  className="vaceailogo"
                  initial={{ opacity: 0, scale: 0.5 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.5, duration: 0.25 }}
                  viewport={{ root: scrollRef }}
              >
                <div className="vaceai2">VACE.AI</div>
              </motion.div>
              <motion.div
                  className="arrowframe"
                  initial={{ opacity: 0, scale: 0.5 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.75, duration: 0.25 }}
                  viewport={{ root: scrollRef }}
              >
                <img className="arrow-icon" alt="" src="/arrow.svg" />
              </motion.div>
              <motion.div
                  className="outputs"
                  initial={{ opacity: 0, scale: 0.5 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 1, duration: 0.25 }}
                  viewport={{ root: scrollRef }}
              >
                <b className="your-questions">Practice Questions</b>
                <img
                  className="refineddoc-icon"
                  alt=""
                  src="/refineddoc@2x.png"
                />
              </motion.div>
            </div>
          </div>
          <div className="feedback">
            <div className="brainstormingviz1">
              <motion.div
                className="videowrapper"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
                <b className="you-and-vaceai-container">Video Response</b>
                <img className="video-icon1" alt="" src="/video@2x.png" />
              </motion.div>
              <motion.div
                className="arrowframe"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.25, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
                <img className="arrow-icon1" alt="" src="/arrow.svg" />
              </motion.div>
              <motion.div
                className="vaceailogo1"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.5, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
                <div className="vaceai2">VACE.AI</div>
              </motion.div>
              <motion.div
                className="arrowframe3"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.75, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
              <img className="arrow-icon1" alt="" src="/arrow.svg" />
              </motion.div>
              <motion.div
                className="videowrapper"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
                <b className="your-questions">Feedbacks</b>
                <div className="feedbackexample">
                  <b className="clarity2">Clarity</b>
                  <div className="feedbackcontent">
                    <div className="feedbacktexts">
                      <div className="your-questions">
                        <span className="comments">{`Comments: `}</span>
                        <span className="the-interviewees-response">{`The interviewee's response was somewhat clear, but there were a lot of filler words and hesitations, which made it difficult to follow their train of thought. `}</span>
                      </div>
                      <div className="your-questions">
                        <span className="comments">Improvements</span>
                        <span className="the-interviewees-response">
                          : The interviewee should work on reducing the use of
                          filler words like "um" and "uh" to improve the clarity
                          of their response.
                        </span>
                      </div>
                    </div>
                    <div className="feedbackviz">
                      <img
                        className="feedbackcircle-icon"
                        alt=""
                        src="/feedbackcircle.svg"
                      />
                      <b className="b">95</b>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="brainstormingtext1">
              <div className="brainstorm-tailored-questions">{`Receive Actionable & Objective Feedback`}</div>
              <div className="brainstorming-questions-can">
                Without quality feedback, it is extremely hard to improve your
                interview. It is hard for anyone to give a detailed (and honest)
                analysis of what you just said, but interviews can. It produces
                actionable and objective feedback on your video response to the
                criteria such as Clarity, Confidence, Relevance, and Job Fit to
                accelerate your practice.
              </div>
            </div>
          </div>
          <div className="brainstorming2">
            <div className="brainstormingtext">
              <div className="brainstorm-tailored-questions">
                Track Your Progress Meaningfully
              </div>
              <div className="brainstorming-questions-can">
                Do you have an experience watching yourself speaking in a video
                and feeling really weird? There is a huge opportunity for growth
                by looking back at your old self. The vace.ai allows you to
                revisit past recordings to understand your strengths and
                weaknesses from a third person’s point of view so that you can
                know your next steps.
              </div>
            </div>
            <div className="brainstormingviz2">
              <motion.div
                className="videowrapper"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
                <b className="your-questions">Feedbacks</b>
                <div className="feedbackexample">
                  <b className="clarity2">Clarity</b>
                  <div className="feedbackcontent">
                    <div className="feedbacktexts">
                      <div className="your-questions">
                        <span className="comments">{`Comments: `}</span>
                        <span className="the-interviewees-response">{`The interviewee's response was somewhat clear, but there were a lot of filler words and hesitations, which made it difficult to follow their train of thought. `}</span>
                      </div>
                      <div className="your-questions">
                        <span className="comments">Improvements</span>
                        <span className="the-interviewees-response">
                          : The interviewee should work on reducing the use of
                          filler words like "um" and "uh" to improve the clarity
                          of their response.
                        </span>
                      </div>
                    </div>
                    <div className="feedbackviz">
                      <img
                        className="feedbackcircle-icon"
                        alt=""
                        src="/feedbackcircle.svg"
                      />
                      <b className="b">95</b>
                    </div>
                  </div>
                </div>
              </motion.div>
              <motion.div
                className="arrowframe"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.5, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
                <img className="arrowlong-icon" alt="" src="/arrowlong.svg" />
              </motion.div>
              <motion.div
                className="arrowframe4"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.5, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
                <img className="arrow-icon1" alt="" src="/arrow.svg" />
              </motion.div>
              <motion.div
                className="videowrapper"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1, duration: 0.25 }}
                viewport={{ root: scrollRef }}
              >
                <b className="your-questions">Tracking</b>
                <img className="image-10-icon" alt="" src="/image-10@2x.png" />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      <div className="pricing" id='pricing'>
        <b className="pricing1">Pricing</b>
        <motion.div
          className="plans"
          initial={{ opacity: 0, scale: 1 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.25, duration: 0.5 }}
          viewport={scrollRef}
        >
          <div className="freeplan">
            <div className="plantitle">
              <div className="target">
                <img className="icon-person" alt="" src="/-icon-person.svg" />
                <div className="individual">Individual</div>
              </div>
              <b className="free">Free</b>
              <div className="div">$0</div>
            </div>
            <div className="plancontent">
              <div className="session-month">1 Session / month</div>
              <div className="session-month">5 Questions / month</div>
              <div className="session-month">10 Feedbacks / month</div>
            </div>
            <motion.div
              className="planbutton"
              whileHover={{ scale: 1.1, x: 0 }}
              whileTap={{ scale: 0.9, x:0 }}
            >
              <div className="signup">
                <div className="sign-up"><Button to={'/auth'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>SIGN UP</p></Button></div>
              </div>
            </motion.div>
          </div>
          <div className="freeplan">
            <div className="plantitle">
              <div className="target">
                <img className="icon-person" alt="" src="/-icon-person.svg" />
                <div className="individual">Individual</div>
              </div>
              <b className="free1">10 Feedbacks</b>
              <div className="div">$5</div>
            </div>
            <div className="plancontent">
              <div className="session-month">1 Session</div>
              <div className="session-month">5 Questions</div>
              <div className="session-month">10 Feedbacks</div>
            </div>
            <motion.div
              className="planbutton"
              whileHover={{ scale: 1.1, x: 0 }}
              whileTap={{ scale: 0.9, x:0 }}
            >
              <div className="signup">
                <div className="sign-up"><Button to={'/auth'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>BUY NOW</p></Button></div>
              </div>
            </motion.div>
          </div>
          <div className="proplan">
            <div className="plantitle">
              <div className="target">
                <img className="icon-person" alt="" src="/-icon-person.svg" />
                <div className="individual">Individual</div>
              </div>
              <b className="free">Pro</b>
              <div className="div">$10 / mo</div>
            </div>
            <div className="plancontent">
              <div className="session-month">5 Sessions / month</div>
              <div className="session-month">100 Questions / month</div>
              <div className="session-month">200 Feedbacks / month</div>
              <div className="session-month">Progress Tracking</div>
            </div>
            <motion.div
              className="planbutton"
              whileHover={{ scale: 1.1, x: 0 }}
              whileTap={{ scale: 0.9, x:0 }}
            >
              <div className="signup">
                <div className="sign-up"><Button to={'/auth'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>SUBSCRIBE</p></Button></div>
              </div>
            </motion.div>
          </div>
          <div className="proplan">
            <div className="plantitle">
              <div className="target">
                <img className="icon-person" alt="" src="/-icon-people.svg" />
                <div className="individual">Institution</div>
              </div>
              <b className="free">Edu</b>
              <div className="div">$2,000+ / mo</div>
            </div>
            <div className="plancontent">
              <div className="session-month">100 Sessions / month</div>
              <div className="session-month">2000 Questions / month</div>
              <div className="session-month">4000 Feedbacks / month</div>
              <div className="session-month">{`Customizable Criteria `}</div>
              <div className="session-month">Progress Tracking</div>
            </div>
            <motion.div
              className="planbutton"
              whileHover={{ scale: 1.1, x: 0 }}
              whileTap={{ scale: 0.9, x:0 }}
            >
              <div className="signup">
                <div className="sign-up"><Button to={'mailto:propagate.jpn@gmail.com'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem' }}>CONTACT US</p></Button></div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
      <div className="faq" id='faq'>
        <b className="your-questions">FAQ</b>
        <motion.div
          className="faqcontent"
          initial={{ opacity: 0, scale: 1 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.25, duration: 0.5 }}
          viewport={scrollRef}
        >
          <div className="leftcontent">
            <div className="leftcontent">
              <div className="brainstorm-tailored-questions">
                Q. How does vace.ai secure user data? Is it safe?
              </div>
              <div className="a-our-top-container">
                <span className="comments">{`A. `}</span>
                <span className="the-interviewees-response">
                  Our top priority is to secure your data. We continue to deploy
                  our best safety measures to provide you with the safest
                  platform for your data security.
                </span>
              </div>
            </div>
            <div className="leftcontent">
              <div className="brainstorm-tailored-questions">
                Q. Does it support languages other than English?
              </div>
              <div className="a-our-top-container">
                <span className="comments">{`A. `}</span>
                <span className="the-interviewees-response">{`We currently support English and Japanese. `}</span>
              </div>
            </div>
          </div>
          <div className="leftcontent">
            <div className="leftcontent">
              <div className="brainstorm-tailored-questions">
                Q. Is there a limit for the video to upload?
              </div>
              <div className="a-yes-there-container">
                <span className="comments">{`A. `}</span>
                <span className="the-interviewees-response">
                  Yes, there is a limit of 2 minutes per video and 50 videos in
                  total. The other limits are 500 words for job descriptions and
                  1 page of PDF for resume.
                </span>
              </div>
            </div>
            <img className="faqimg-icon" alt="" src="/faqimg@2x.png" />
          </div>
        </motion.div>
      </div>
      <motion.div
        className="contact"
        id='contact'
        initial={{ opacity: 0, scale: 1 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.25, duration: 1 }}
        viewport={scrollRef}
      >
        <div className="vaceai4">VACE.AI</div>
        <b className="your-companion-for">
          Your Companion for Interview Practice
        </b>
        <div className="contactbuttons">
        <Button to={'mailto:propagate.jpn@gmail.com'} transparent>
          <div className="contactus">
            <div className="sign-up"><p style={{ color: '#ffffff', marginTop: 0, marginBottom: 0 }}>CONTACT US</p></div>
          </div>
        </Button>
          <a
            className="propagatejpngmailcom"
            href="mailto:propagate.jpn@gmail.com"
            target="_blank"
          >
            propagate.jpn@gmail.com
          </a>
        </div>
      </motion.div>
      <div className="footer">
        <div className="topboarder">
          <div className="fottercontent">
            <div className="rights">
              <div className="propagate-2024-all">
                © Propagate 2024. All rights reserved.
              </div>
            </div>
            <div className="medialogos">
              <img className="linkedin-icon" alt="" src="/linkedin@2x.png" />
              <img className="instagram-icon" alt="" src="/instagram@2x.png" />
              <img className="facebook-icon" alt="" src="/facebook@2x.png" />
              <img className="twitter-icon" alt="" src="/twitter@2x.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vaceai;
